import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./AuthConfig";
import { Container, Navbar as BsNavbar, Nav, Dropdown } from "react-bootstrap";

export const Navbar: React.FC = () => {
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const account = accounts.length > 0 ? accounts[0] : null;
    const userName = account?.name ?? account?.username ?? 'User';

    useEffect(() => {
        if (!isAuthenticated) {
            instance.loginRedirect(loginRequest).catch(e => console.error(e));
        }
    }, [instance, isAuthenticated]);

    const handleLogout = () => {
        instance.logoutRedirect().catch(e => console.error(e));
    };

    return (
        <BsNavbar bg="white" variant="light" sticky="top" className="pretty-navbar" style={{ height: '70px' }}>
            <Container fluid>
                <BsNavbar.Brand href="/">
                    <img
                        src="/transparent.png"
                        alt="Logo"
                        style={{ marginRight: '10px', width: '80px', height: '80px', verticalAlign: 'middle', position: 'relative', top: '5px' }}
                    />
                    <div style={{ display: 'inline-flex', verticalAlign: 'middle', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '0px' }}>
                        <div style={{ color: '#EB0A1E', fontWeight: 'bold', lineHeight: 1 }}>GAP</div>
                        <div style={{ lineHeight: 1 }}>EV Charging Station Map</div>
                    </div>
                </BsNavbar.Brand>

                <Nav className="ms-auto">
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="outline-dark" id="user-dropdown">
                            <i className="far fa-user me-2" /> <strong>{userName}</strong>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Nav>
            </Container>
        </BsNavbar>
    );
};